import { JSONSchema7 } from 'json-schema';
import PageState from '../../Shared/pageState';
import getControlsFromPageSchema from '../../Shared/jsonSchemaUtilities/getControlsFromPageSchema';
import { WorkflowEngineState, LastUpdatedInfo } from '../workflowEngineReducer';

export default (state: WorkflowEngineState, payload: LastUpdatedInfo) => {
  state.pages.forEach((page: PageState) => {
    if (page.id === payload.externalId) {
      page.schema = JSON.parse(payload.metadata) as JSONSchema7;
      page.controls = getControlsFromPageSchema(page.id, page.schema);
      return;
    }
  });

  return {
    ...state,
    lastUpdatedDate: payload.lastUpdatedDate,
    lastUpdatedBy: payload.lastUpdatedBy
  };
};
